





































import { Component, Mixins, Prop } from 'vue-property-decorator'
import type { Reaction } from '@/dtos/static-assets/get'
import { CurrentAdminManager } from '@/mixins/current-admin-manager'
import { staticAssetsModule } from '@/stores/static-assets-store'

@Component
export default class SmMenu extends Mixins(CurrentAdminManager) {
  @Prop({ default: () => [] })
  private readonly selectedReactions!: string[]

  @Prop({ required: true, default: false })
  private isAvailableReaction!: boolean

  private get reactions(): Reaction[] { return staticAssetsModule.reactions }

  private _selected(assetId: string): boolean {
    return this.selectedReactions?.some(selectedAssetId => selectedAssetId === assetId)
  }
}
